// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
// import { Message } from 'element-ui';
import BaiduMap from 'vue-baidu-map';
import VueWechatTitle from 'vue-wechat-title';
import store from './store/index'
import permission from './router/permission'
import Browser from './utils/Browser'

Vue.use(BaiduMap, {
    ak: '9cUG6fmoq7sN67lELvZszGiMjlS23KHe'
})
Vue.use(VueWechatTitle)

Vue.use(Element)
Vue.config.productionTip = false
Vue.prototype.$store = store

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js